import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "as", "sx"];
import React__default, { forwardRef } from 'react';
import { ButtonBase } from './ButtonBase.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var LinkButton = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'a' : _ref$as,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? defaultSxProp : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(ButtonBase, _extends({
    as: Component
    // @ts-expect-error ButtonBase wants both Anchor and Button refs
    ,

    ref: forwardedRef,
    sx: sx
  }, props), children);
});
export { LinkButton };